import dasherize from "dasherize";

export async function updateAddress(api, addressData) {
  let location;
  if (addressData && addressData.location) {
    location = await api.createResource(
      "location",
      dasherize(addressData.location),
    );
  }
  const address = await api.updateResource(
    "address",
    dasherize({ ...addressData, location: location }),
  );

  return address;
}

export async function createAddress(api, address) {
  let location;
  if (address && address.location) {
    location = await api.createResource(
      "location",
      dasherize(address.location),
    );
  }

  const createdAddress = await api.createResource(
    "address",
    dasherize({
      ...address,
      id: undefined,
      location: location,
    }),
  );

  return createdAddress;
}
